import {useUnifyAdminStore} from '../../AdminStore';
import * as StyledComponents from '../StyledComponents';
import {SWITCH_LABEL_POSITIONS} from 'cdk-radial';
import { t } from 'i18next';

export const CampaignShowLogoStatusField = (): JSX.Element => {

    /**
     * Data Store
     */
    const campaignItems = useUnifyAdminStore((state) => state.campaignItems);
    const archiveSwitch = useUnifyAdminStore((state) => state.campaignArchiveSwitch);
    const updateCreateCampaignData = useUnifyAdminStore(
        (state) => state.updateCreateCampaignData
    );
    const permissions = useUnifyAdminStore(state => state.permissions) 

    const handleUpdateEnablementField = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        return updateCreateCampaignData({
            fieldName: event.target.name,
            value: event.target.checked
        });
    };

    return (
            <StyledComponents.StyledCampaignShowLogoSwitch
                data-testId="campaign-shologo-status-switch"
                id="campaign-showlogo-status-switch"
                label={t('campaigns.showLogo')}
                name="showLogo"
                onChange={(e:any)=>handleUpdateEnablementField(e)} // todo : check switch
                placeholder="Campaign Enablement"
                value={campaignItems.showLogo}
                checked={campaignItems.showLogo}
                labelPosition={SWITCH_LABEL_POSITIONS.BEFORE}
                isDisabled={archiveSwitch || (campaignItems.id
                    && (!permissions?.hasCampaignUpdatePermissions && !permissions?.hasCampaignSuperAdminPermissions))}
            />
    );
};
